module.exports = __webpack_public_path__ + "static/media/smart-watch.2c543b2f.svg";